import React, { PureComponent } from 'react'
import katex from 'katex'
import PropTypes from 'prop-types'

import 'katex/dist/katex.css'

// Styled Components
import { Error } from './RenderKatex.styles'

/**
 * Based heavily on https://github.com/zzish/react-latex
 */
class RenderKatex extends PureComponent {
    static propTypes = {
        children: PropTypes.string,
        displayMode: PropTypes.bool,
        renderErrors: PropTypes.bool
    }

    static defaultProps = {
        children: '',
        displayMode: false,
        renderErrors: false
    }

    stripDollars(stringToStrip) {
        if (stringToStrip[1] === '$') {
            stringToStrip = stringToStrip.slice(2, -2)
        } else {
            stringToStrip = stringToStrip.slice(1, -1)
        }

        return stringToStrip
    }

    processResult(result, options) {
        const newResult = result.map(r => {
            if (r.type === 'text') {
                return r.string
            }

            return katex.renderToString(r.string, options)
        })

        return newResult.join(' ')
    }

    renderKatex(katexString, options) {
        // Remove potential HTML
        katexString = katexString.replace(/(<([^>]+)>)/gi, '')
        const regularExpression = /\$\$[\s\S]+?\$\$|\$[\s\S]+?\$/g

        const result = []

        const latexMatch = katexString.match(regularExpression)
        const stringWithoutLatex = katexString.split(regularExpression)

        if (latexMatch) {
            stringWithoutLatex.forEach((s, index) => {
                result.push({
                    string: s,
                    type: 'text'
                })

                if (latexMatch[index]) {
                    result.push({
                        string: this.stripDollars(latexMatch[index]),
                        type: 'latex'
                    })
                }
            })
        } else {
            result.push({
                katexString,
                type: 'text'
            })
        }

        return this.processResult(result)
    }

    render() {
        const { children, displayMode, renderErrors } = this.props
        let katex, error

        try {
            katex = this.renderKatex(children, { displayMode })
        } catch (err) {
            error = err.message
        }

        if (katex) return <span dangerouslySetInnerHTML={{ __html: katex }} />

        if (renderErrors && error) return <Error>{error}</Error>

        return null
    }
}

export default RenderKatex



// WEBPACK FOOTER //
// ./src/components/RenderKatex.js